import { Toaster } from "react-hot-toast";
import RouteConfig from "./routes/routes.config";

function App() {
  return (
    <>
      <RouteConfig />
      <Toaster />
    </>
  );
}

export default App;
